import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const RFIManagementWizardRoute: RouteType = {
  name: "RFIManagementWizard",
  path: "/workflows/rfi-management",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "RFI Management",
      component: () => import("./RFIManagementWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./RFIManagementWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const jobStore = rootStore.jobStore as ServiceStore;
      const contactsStore = rootStore.contactsStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const rfisStore = rootStore.rfisStore as ServiceStore;

      await Promise.all([
        jobStore?.find(),
        contactsStore?.find(),
        userStore?.find(),
        rfisStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for RFI management:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).rfiManagementWizardStore;
    store?.reset();
  },
};

export default RFIManagementWizardRoute;